if (!window.__CUSTOM_THEME_LOADED__) {
    window.__CUSTOM_THEME_LOADED__ = true;
} else {
    console.warn("Custom theme script prevented duplicate execution.");
}

if (!window.__CUSTOM_THEME_EXECUTED__) {

    window.__CUSTOM_THEME_EXECUTED__ = true;

    window.__SLICK_REGISTRY__ = window.__SLICK_REGISTRY__ || new WeakSet();

    /* ---------------- SAFE SLICK INIT ---------------- */

    function safeInitSlick($el, options) {

        if (!$el || !$el.length) return;

        const node = $el[0];

        if (window.__SLICK_REGISTRY__.has(node)) return;

        if ($el.hasClass('slick-initialized')) return;

        try {

            $el.slick(options);

            window.__SLICK_REGISTRY__.add(node);

        } catch (e) {

            console.warn("Slick prevented:", e);

        }

    }

    /* ---------------- DOM READY ---------------- */

    document.addEventListener("DOMContentLoaded", function() {

        const $doc = $(document);

        /* ---------------- VIDEO ---------------- */

        $doc.on('click', '#WaveVideoBtn', function() {

            const video = document.querySelector('#wavesvideo');

            if (video) {
                video.controls = true;
                video.play();
            }

            document.querySelector('.video-box-wrapper')?.classList.add('remove-overlay');

        });

        /* ---------------- PRODUCT TABS STICKY ---------------- */

        const header = document.querySelector("#header");
        const tabsWrapper = document.querySelector("#productTabs");
        const tabsUL = document.querySelector("#productTabs ul.product-tabs");

        if (header && tabsWrapper && tabsUL) {

            let spacer = tabsWrapper.querySelector(".tabs-spacer");

            if (!spacer) {

                spacer = document.createElement("div");
                spacer.className = "tabs-spacer";
                tabsWrapper.parentNode.insertBefore(spacer, tabsWrapper.nextSibling);

            }

            function updateHeaderHeight() {
                tabsUL.style.setProperty("--header-height", header.offsetHeight + "px");
            }

            updateHeaderHeight();
            window.addEventListener("resize", updateHeaderHeight);

            let ticking = false;

            function onScroll() {

                const rect = tabsWrapper.getBoundingClientRect();
                const headerHeight = header.offsetHeight;

                if (rect.top <= headerHeight) {

                    if (!tabsUL.classList.contains("tabs-sticky")) {

                        spacer.style.height = tabsUL.offsetHeight + "px";
                        tabsUL.classList.add("tabs-sticky");
                        tabsUL.style.setProperty("--tabs-height", tabsUL.offsetHeight + "px");

                    }

                } else {

                    if (tabsUL.classList.contains("tabs-sticky")) {

                        tabsUL.classList.remove("tabs-sticky");
                        spacer.style.height = "";
                        tabsUL.style.removeProperty("--tabs-height");

                    }

                }

                ticking = false;

            }

            window.addEventListener("scroll", function() {

                if (!ticking) {

                    requestAnimationFrame(onScroll);
                    ticking = true;

                }

            });

            onScroll();

            /* TAB CLICK */

            tabsUL.addEventListener("click", function(e) {

                const a = e.target.closest("a.tablink");
                if (!a) return;

                e.preventDefault();

                const target = document.querySelector(a.getAttribute("href"));
                if (!target) return;

                const tabsHeight = tabsUL.offsetHeight;
                const offset = header.offsetHeight + tabsHeight + 8;

                const finalPos = target.getBoundingClientRect().top + window.scrollY - offset;

                window.scrollTo({
                    top: finalPos,
                    behavior: "smooth"
                });

                tabsUL.querySelectorAll("li").forEach(li => li.classList.remove("active"));
                a.closest("li").classList.add("active");

            });

        }

        /* ---------------- MAIN SLIDER PROGRESS ---------------- */

        const $slider = $('.main-text-img');
        const $progressBar = $('.progress');
        const $progressBarLabel = $('.slider__label');

        if ($slider.length) {

            $slider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {

                const calc = ((nextSlide) / (slick.slideCount - 1)) * 100;

                $progressBar
                    .css('background-size', calc + '% 100%')
                    .attr('aria-valuenow', calc);

                $progressBarLabel
                    .text(calc + '% completed')
                    .css('width', calc + '%');

            });

        }

        /* ---------------- READ MORE ---------------- */

        const desc = document.querySelector(".product-single__description");

        if (desc) {

            const moreContent = desc.querySelector(".read-more-content");

            if (moreContent) {

                const btn = document.createElement("button");

                btn.className = "read-more-btn";
                btn.textContent = "Read More";

                moreContent.insertAdjacentElement("afterend", btn);

                btn.addEventListener("click", function() {

                    moreContent.classList.toggle("open");

                    btn.textContent = moreContent.classList.contains("open") ?
                        "Read Less" :
                        "Read More";

                });

            }

        }

        /* ---------------- SLICK INITIALIZATIONS ---------------- */

        if (typeof jQuery === 'undefined' || typeof $.fn.slick === 'undefined') return;


/* INGREDIENTS */

$('.slick-ingredients').each(function() {

    safeInitSlick($(this), {
        slidesToShow: 3,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        speed: 400,
        swipeToSlide: true,
        adaptiveHeight: false,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 2 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 1.2, arrows: false }
            }
        ]
    });

});


        /* INGREDIENT FILTER TABS */

       /* INGREDIENT FILTER TABS - FIXED */

$(document).on('click', '.ingredient-tab', function () {

    const filter = $(this).data('filter');
    const $slider = $('.slick-ingredients');

    $('.ingredient-tab').removeClass('active');
    $(this).addClass('active');

    if (!$slider.hasClass('slick-initialized')) return;

    // reset first
    $slider.slick('slickUnfilter');

    if (filter !== 'all') {
        $slider.slick('slickFilter', function () {
            const itemFilters = $(this).data('filter');

            return itemFilters && itemFilters.includes(filter);
        });
    }

});


        /* QUOTES */

        $('.slick-quotes-slider').each(function() {

            const $el = $(this);

            safeInitSlick($el, {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: $el.data('arrows') === true,
                dots: $el.data('dots') === false,
                autoplay: $el.data('autoplay') === true,
                autoplaySpeed: parseInt($el.data('speed'), 10) || 3000,
                infinite: true,
                adaptiveHeight: true,
                swipeToSlide: true,
                rtl: $el.data('rtl') === true
            });

        });


        /* BLOG */

        $('.slick-blog-slider').each(function() {

            const $el = $(this);

            safeInitSlick($el, {
                slidesToShow: 3,
                slidesToScroll: 1,
                arrows: true,
                dots: false,
                autoplay: $el.data('autoplay') === true,
                autoplaySpeed: parseInt($el.data('speed'), 10) || 3000,
                infinite: true,
                swipeToSlide: true,
                rtl: $el.data('rtl') === true,
                responsive: [{
                        breakpoint: 1024,
                        settings: {
                            slidesToShow: 2
                        }
                    },
                    {
                        breakpoint: 768,
                        settings: {
                            slidesToShow: 1,
                            arrows: false,
                            centerMode: true
                        }
                    }
                ]
            });

        });
$('.storeFeatures').each(function () {

    safeInitSlick($(this), {
        infinite: true,
        arrows: false,
        dots: false,
        variableWidth: true,
        swipeToSlide: true,
        autoplay: false,
        autoplaySpeed: 2000,
        speed: 800,
        cssEase: 'linear',
        pauseOnHover: false
    });

});

        /* OFFERS */

        $('.offers-slider').each(function() {

            safeInitSlick($(this), {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
                arrows: false,
                infinite: false,
                autoplay: true,
                autoplaySpeed: 3000,
                adaptiveHeight: true,
                draggable: true,
                swipe: true,
                responsive: [{
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 1.3,
                        dots: false
                    }
                }]
            });

        });


        /* HOW */

        $('.how-slider').each(function () {

        var $slider = $(this);

        if ($slider.hasClass('slick-initialized')) return;

        $slider.slick({
            slidesToShow: 2,
            slidesToScroll: 1,
            initialSlide: 0,
            infinite: false,
            arrows: false,
            dots: false,
            draggable: true,
            swipe: true,
            swipeToSlide: true,
            touchThreshold: 10,
            speed: 400,
            cssEase: 'ease',

            responsive: [
            {
                breakpoint: 991,
                settings: {
                slidesToShow: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    arrows: true,
                slidesToShow: 1.2
                }
            }
            ]
        });

        });



        /* PRODUCTS LAYOUT SLIDER */

        $('.products-layout-slider').each(function() {

            safeInitSlick($(this), {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                fade: true,
                infinite: true,
                appendArrows: '.layout-slider-nav'
            });

            $(this).slickAnimation();

        });

    });

    /* ---------------- NAV ANIMATION ---------------- */

    $(document).on('click touch', '.slick-nav', function(e) {

        e.preventDefault();

        const arrow = $(this);

        if (!arrow.hasClass('animate')) {

            arrow.addClass('animate');

            setTimeout(function() {
                arrow.removeClass('animate');
            }, 1600);

        }

    });




    /* ---------------- SLIDE CONTROL ---------------- */

    $(document).on('click', '.slide-contro[data-slide]', function(e) {

        e.preventDefault();

        const slideno = $(this).data('slide');

        $('.products-layout-slider').slick('slickGoTo', slideno - 1);

    });

}

$(document).ready(function(){

$('.pr-related-slider').not('.slick-initialized').slick({

    slidesToShow:2,
    slidesToScroll:1,

    arrows:false,
    dots:true,

    infinite:false,
    draggable:true,
    swipe:true,

    responsive:[
        {
        breakpoint:768,
            settings:{
            slidesToShow:1.3,
            dots:false
            }
        }
    ]

});

});

;(function () {
    if (window.__codexCartDrawerPatchInstalled) return;
    window.__codexCartDrawerPatchInstalled = true;

    var lockState = null;

    function saveInlineStyles() {
        return {
            htmlOverflow: document.documentElement.style.overflow,
            bodyPosition: document.body.style.position,
            bodyTop: document.body.style.top,
            bodyLeft: document.body.style.left,
            bodyRight: document.body.style.right,
            bodyWidth: document.body.style.width,
            bodyOverflow: document.body.style.overflow
        };
    }

    function lockPageScroll() {
        if (lockState) return;

        lockState = saveInlineStyles();
        lockState.scrollY = window.pageYOffset || document.documentElement.scrollTop || 0;

        document.documentElement.classList.add('cart-drawer-scroll-lock');
        document.body.classList.add('cart-drawer-scroll-lock', 'overflow-hidden');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.top = '-' + lockState.scrollY + 'px';
        document.body.style.left = '0';
        document.body.style.right = '0';
        document.body.style.width = '100%';
        document.body.style.overflow = 'hidden';
    }

    function unlockPageScroll() {
        if (!lockState) {
            document.documentElement.classList.remove('cart-drawer-scroll-lock');
            document.body.classList.remove('cart-drawer-scroll-lock', 'overflow-hidden');
            return;
        }

        var scrollY = lockState.scrollY || 0;

        document.documentElement.classList.remove('cart-drawer-scroll-lock');
        document.body.classList.remove('cart-drawer-scroll-lock', 'overflow-hidden');
        document.documentElement.style.overflow = lockState.htmlOverflow || '';
        document.body.style.position = lockState.bodyPosition || '';
        document.body.style.top = lockState.bodyTop || '';
        document.body.style.left = lockState.bodyLeft || '';
        document.body.style.right = lockState.bodyRight || '';
        document.body.style.width = lockState.bodyWidth || '';
        document.body.style.overflow = lockState.bodyOverflow || '';
        lockState = null;
        window.scrollTo(0, scrollY);
    }

    function expandDrawer(drawer) {
        if (drawer && drawer.classList.contains('active')) {
            drawer.classList.add('is-expanded');
        }
    }

    function bindDrawerTap(drawer) {
        if (!drawer || drawer.dataset.codexDrawerTapBound === 'true') return;
        drawer.dataset.codexDrawerTapBound = 'true';

        drawer.addEventListener('click', function (event) {
            if (!event.target.closest || !event.target.closest('#CartDrawer')) return;
            if (event.target.closest('.drawer__close')) return;
            expandDrawer(drawer);
        });
    }

    function patchCartDrawer() {
        if (!window.customElements || !customElements.get('cart-drawer')) return;

        var CartDrawer = customElements.get('cart-drawer');
        if (!CartDrawer || CartDrawer.prototype.codexDrawerPatched === true) return;

        var nativeOpen = CartDrawer.prototype.open;
        var nativeClose = CartDrawer.prototype.close;
        CartDrawer.prototype.codexDrawerPatched = true;

        CartDrawer.prototype.open = function () {
            var result = nativeOpen.apply(this, arguments);
            this.classList.remove('is-expanded');
            bindDrawerTap(this);
            lockPageScroll();
            return result;
        };

        CartDrawer.prototype.close = function () {
            var result = nativeClose.apply(this, arguments);
            this.classList.remove('is-expanded');
            unlockPageScroll();
            return result;
        };

        document.querySelectorAll('cart-drawer').forEach(bindDrawerTap);
    }

    if (window.customElements && customElements.whenDefined) {
        customElements.whenDefined('cart-drawer').then(patchCartDrawer);
    } else {
        document.addEventListener('DOMContentLoaded', patchCartDrawer);
    }
})();
